import { render } from "./CustomAutocomplete.vue?vue&type=template&id=31c141f0&scoped=true"
import script from "./CustomAutocomplete.vue?vue&type=script&lang=js"
export * from "./CustomAutocomplete.vue?vue&type=script&lang=js"

import "./CustomAutocomplete.vue?vue&type=style&index=0&id=31c141f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c141f0"]])

export default __exports__